// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__22JUb","label":"SetPasswdForm_label__3Xe0W"};